import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/app/[locale]/(public)/iframe_button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
